module.exports = {
	"account.user.driving.licence.already.exist": "There is another account with this driver's license number.",
	"account.user.login.already.exist": "This email is already used by another account.",
	"account.user.suspended": "Unable to perform this action because the user is suspended",
	"action.add.payment": "Add payment method",
	"action.complete.my.account": "Complete my account",
	"action.confirm.welcome.msg": "Let's go",
	"action.create.my.account": "Create my account",
	"action.search.update.bookings": "Verify availabilities",
	"action.update.payment": "Update payment method",
	"anonymous.search.location.not.available": "The search is not available for this location",
	"booking.accept_usage_terms.link.label": "Terms of use",
	"booking.accept_usage_terms.text": "By clicking \"Confirm\", you declare on your word of honor to accept the terms and conditions of service and be currently holding a valid driver's license if you use the car-sharing service. More in the {link}.",
	"booking.accept_usage_terms.title": "Terms of use",
	"booking.action.cancel.forbidden": "You can no longer cancel booking",
	"booking.action.edit.forbidden": "You can no longer edit a booking",
	"booking.add.calendar": "Add to calendar",
	"booking.confirm": "Confirm booking",
	"booking.confirm_and_pay": "Confirm and pay",
	"booking.deposit": "Security deposit",
	"booking.deposit.b": "A bank deposit of {damageSafetyDeposit} {currency} will be charged when you confirm your reservation. \nThis deposit can be used to cover any damage caused to the vehicle during your trip.\n\nIf the vehicle will be returned without any damage or overtime, only the price of {bookingPrice} {currency} will be charged.",
	"booking.deposit.d": "A bank deposit in the amount of {bufferPrice} {currency} will be made when you confirm your reservation. \nThis includes the price of your reservation and a charge to cover any overruns.\n\nWithout an overrun or vehicle damage, only {bookingPrice} {currency} will be debited from your account.",
	"booking.deposit.db": "Two bank deposits will be charged when you confirm your reservation:\n— First one in the amount of {bufferPrice} {currency}, including the price of your reservation and a charge to cover any overruns.\n— Second one in the amount of {damageSafetyDeposit} {currency} to cover any damage caused to the vehicle during your reservation.\n\nWithout any overrun or vehicle damage, only {bookingPrice} {currency} will be charged.",
	"booking.deposit.info": "A bank deposit will be placed for your booking",
	"booking.payment.prebilling.refused.error": "The transaction was refused because the debit on your credit card failed. Please repeat with another card. If the problem persists, please check with your bank.",
	"booking.payment.prebilling.technical.error": "There was an error during payment. Please try again later.",
	"booking.success.sub.title": "Thank you for using our service!",
	"booking.success.title": "Congratulations, your booking is successfully created!",
	"booking.type.label": "Booking type",
	"booking.type.one_way": "One way",
	"booking.type.return_trip": "Return trip",
	"booking.update.period.expired": "The period to update the booking dates has expired",
	"booking.usage.business": "Business",
	"booking.usage.private": "Private",
	"booking.view_payment_terms.title": "Terms of payment",
	"booking.voucher.different.code": "You cannot modify your promo code",
	"booking.voucher.placeholder": "I have a voucher code",
	"car.AUTOMATIC": "Automatic",
	"car.DIESEL": "Diesel",
	"car.ELECTRIC": "Electric",
	"car.FOLDING_SEATS": "Folding seats",
	"car.GPS": "GPS",
	"car.HYBRID": "Hybrid",
	"car.LPG": "GPL",
	"car.MANUAL": "Manual",
	"car.PETROL": "Petrol",
	"car.RADIO_CD": "Radio",
	"car.booking_details": "Booking details",
	"car.color": "Color",
	"car.compact_cars": "Compact",
	"car.description": "Description",
	"car.details": "Vehicle details",
	"car.doors": "Doors",
	"car.filter.COMMERCIAL": "Commercial",
	"car.filter.PASSENGER": "Tourism",
	"car.filter.accessories.air_conditioning": "Air conditioning",
	"car.filter.accessories.baby_seat": "Baby seat",
	"car.filter.accessories.bluetooth": "Bluetooth",
	"car.filter.accessories.large_truck": "Large truck",
	"car.filter.accessories.radio_cd": "Radio",
	"car.filter.label_nb_persons": "Number of persons",
	"car.filter.other": "Others",
	"car.filter.other-nb": "Others — {nb}",
	"car.filter.vehicle_type": "Vehicle type",
	"car.filter_energy": "Energy",
	"car.filter_gearbox_type": "Gear box type",
	"car.filter_persons": "people",
	"car.for_every_additional_km": "Per additional kilometer",
	"car.km_included": "Km included",
	"car.motorization": "Motorization",
	"car.options": "Options",
	"car.parking_additional_info": "Parking specific details",
	"car.places": "Seats",
	"car.pricing": "Pricing",
	"car.pricing.estimate": "Price estimate",
	"car.pricing.extra_km_cost_per_day": "Price of extra km",
	"car.pricing.free_km_per_day": "Km include / 24 h",
	"car.specifications": "Specifications",
	"car.transmission": "Transmission",
	"car.utility_cars": "Utility",
	"car.version": "Version",
	"company.id.missing.booking.search": "The company id is mandatory for the anonymous booking search",
	"contact_page.phone_call_price": "(FREE CALL FROM A LANDLINE)",
	"contact_page.title_1": "For any questions regarding your car rental,",
	"contact_page.title_2": "do not hesitate to contact us by email.",
	"creditcard.data.insufficient.3ds": "Due to new 3DS2 requirements we ask you to update your payment information.",
	"custom.field.type.boolean": "Yes/No",
	"data.with.colon": "{data}:",
	"document.issue.date": "Issue date",
	"dropzone.inner.info": "Files allowed: JPEG, PNG, PDF",
	"dropzone.inner.title": "Upload your document",
	"error.booking.member_invalid": "Your profile has not yet been validated.",
	"error.booking.no.usage": "No usage for this booking dates",
	"error.booking.no_credit_card": "Please add your credit card information first.",
	"error.booking.same_period": "You already have a reservation planned for this period.",
	"error.change_password.400.bad_request": "Password is incorrect",
	"error.contract.inactive": "The service is not active for your company, please approach your service manager.",
	"error.contract.not-found": "The service is suspended by your company, please approach your service manager.",
	"error.credit.card.refused": "Credit card refused",
	"error.forgot_password.404": "Please check your email, no account matches",
	"error.form.email.already_exists": "Please enter a different email address",
	"error.form.email_invalid": "Please enter a valid email",
	"error.form.inviteCode.notEmpty": "Please provide an invitation code",
	"error.form.password.at_least": "Your password must contain at least 8 characters",
	"error.form.password.at_most": "Your password must contain 25 characters maximum",
	"error.form.password.cannot_reset_same": "Your new password must be different the current one",
	"error.form.password.digit": "Your password must contain 1 number",
	"error.form.password.lower_letter": "Your password must contain 1 lowercase",
	"error.form.password.upper_letter": "Your password must contain 1 capital letter",
	"error.form.password_confirmation.the_same": "Please enter the same password twice",
	"error.form.password_old.the_same": "The new password must be different from the previous passwords used",
	"error.form.required": "Please fill all mandatory fields",
	"error.form.suggestion.address.required": "Please select the address from the list of suggestions",
	"error.form.technical": "Technical error",
	"error.get.site.config": "Failed to load site configuration",
	"error.invite.code.invalid": "The community that you want to join does not exist",
	"error.login.401.unauthorized": "Your email or password is incorrect",
	"error.login.403.user.anonymized": "Your account is being anonymized, you can no longer use it",
	"error.login.422.user.not.enabled": "Your account is not activated, please check your emails and follow the instructions to activate your account.",
	"error.number.above.max": "The value cannot be over {value}",
	"error.number.below.min": "The value cannot be below {value}",
	"error.phone.format.invalid": "Phone number format is incorrect",
	"error.register.without.sso": "You can only subscribe using SSO",
	"error.request_error": "Request error",
	"error.reset_password.401": "The link provided is no longer valid, please request another password on the site",
	"error.search.vehicles.403": "You can't access selected site with current active profile",
	"error.session.expired": "Session expired",
	"error.text.length.long": "This field is limited to {count} characters",
	"error.text.length.short": "This field needs at least {count} characters",
	"error.user.verify.fail": "User verification failed",
	"error_profile_edit_member_approved": "Name and birthday cannot be changed once your profile is validated",
	"faq.contactEmailFallback": "our contact email",
	"faq.contactPhoneFallback": "the bottom of the page",
	"faq.other_question": "Can't find the answer to your question?",
	"file_upload_size_exceeded": "The file is too large. Maximum size: 5 MB",
	"footer.label.legal.information": "Legal information",
	"footer.label.personal.data": "Personal data",
	"footer_callUs": "Call us",
	"footer_other": "Other",
	"footer_share": "Follow us",
	"footer_society_about": "About us",
	"footer_society_policy_privacy": "Privacy policy",
	"footer_society_term": "Terms of use",
	"footer_writeUs": "Drop an email",
	"forgot_password.confirmation": "A link to reset your password has been sent to your email address.",
	"forgot_password.description_line1": "Enter email associated with your account.",
	"forgot_password.description_line2": "We will send you a link to reset your password.",
	"forgot_password.submit": "Send me reset link",
	"generic.address": "Address",
	"generic.at": "at",
	"generic.book": "Book",
	"generic.cancel": "Cancel",
	"generic.canceled": "Canceled",
	"generic.city": "City",
	"generic.clear": "Clear",
	"generic.company": "Company",
	"generic.completed": "Completed",
	"generic.country": "Country",
	"generic.email": "Email",
	"generic.end": "End",
	"generic.expires.at": "Expires",
	"generic.extend": "Extend",
	"generic.file": "File",
	"generic.first.name": "First name",
	"generic.last.name": "Last name",
	"generic.location.fixture.label": "Sites",
	"generic.location.history.label": "History",
	"generic.location.search.placeholder": "Search for an address, a city ...",
	"generic.mobile.phone": "Mobile phone",
	"generic.modify": "Modify",
	"generic.mr": "Mr.",
	"generic.mrs": "Mrs.",
	"generic.next": "Next",
	"generic.number": "Number",
	"generic.passport": "Passport",
	"generic.past.placeholder": "Find here your past bookings",
	"generic.phone.number": "Phone number",
	"generic.postal.code": "Postal code",
	"generic.retry": "Retry",
	"generic.save": "Save",
	"generic.send": "Send",
	"generic.start": "Start",
	"generic.text": "Text",
	"generic.today": "Today",
	"generic.upcoming": "Upcoming",
	"generic.updated": "Updated",
	"generic.user": "User",
	"get.sso.config.fail": "This email address is not recognized for SSO login",
	"helpPage_carSharing_issue1_answer": "To register, you simply go to your company's intranet site, you will find a link that will take you to the registration page (Or send a subscription request to {contactEmail}). You will receive a link by email.",
	"helpPage_carSharing_issue1_title": "How to register?",
	"helpPage_carSharing_issue2_answer": "You can reset your password from the website or mobile apps: you will receive in this case your registered email address, a link to set your new password.",
	"helpPage_carSharing_issue2_title": "What if I lost my password?",
	"helpPage_carSharing_issue3_answer": "In case you lost your badge or have a new one, please contact the Call Center at {contactPhone} to reset your badge. A new badge will not work unless it is reset first.",
	"helpPage_carSharing_issue3_title": "What if I lost my badge or have a new one?",
	"helpPage_carSharing_issue4_answer": "The license plate of your vehicle is noted in the confirmation email and in the confirmation SMS. Otherwise, you will find the vehicle on the booking site My Bookings.",
	"helpPage_carSharing_issue4_title": "Which vehicle did I book?",
	"helpPage_carSharing_issue5_answer": "Make sure the date and time are right, the start button is only available from the time of booking. Otherwise you can swipe your badge on the card reader to open the doors of the vehicle.",
	"helpPage_carSharing_issue5_title": "Why can I not find the start button?",
	"helpPage_carSharing_issue6_answer": "If you have made a reservation and the light goes green but the door does not open, press the button located on the handle of the door.",
	"helpPage_carSharing_issue6_title": "Why is there the green light but the doors are still close?",
	"helpPage_carSharing_issue7_answer": "Once you booked the vehicle, you can also edit or cancel your reservation, from the website or the mobile app. In case you need assistance, please contact the Call Center at {contactPhone}.",
	"helpPage_carSharing_issue7_title": "Edit / Cancellation",
	"helpPage_carSharing_issue8_answer": "You cannot badge in advance, you can only open the vehicle starting at the right time.",
	"helpPage_carSharing_issue8_title": "Can I swipe the badge in advance?",
	"helpPage_damages_issue1_answer": "Before starting your reservation, please ensure to notify about the damages with your mobile app, or by calling the Call Center at {contactPhone}.",
	"helpPage_damages_issue1_title": "What to do in case of reserved vehicle being damaged?",
	"helpPage_damages_issue2_answer": "Stay calm and ensure no one is wounded. You are under the insurance coverage. Please contact ASAP the Call Center at {contactPhone} for further instructions.",
	"helpPage_damages_issue2_title": "What to do in case of accident during my reservation?",
	"helpPage_subtitle": "You will find in this section the answers to the most frequently asked questions.",
	"helpPage_tab_carSharing": "Service",
	"helpPage_tab_damages": "Damages",
	"helpPage_tab_vehicles": "Vehicle",
	"helpPage_title": "Frequently asked questions (F.A.Q)",
	"helpPage_vehicles_issue1_answer": "Check your reservation dates and hours, then check if the license plate matches with your booking. Then swipe again by presenting to the reader ONLY your badge. Make sure you use the badge which belongs to the same person who made the booking and that it was not changed between the last booking. In case of a recent change of badge, thank you to contact customer service to make a change in one instant.",
	"helpPage_vehicles_issue1_title": "Why is the vehicle not responding?",
	"helpPage_vehicles_issue2_answer": "Check your reservation dates and hours, then check if the license plate matches with your booking. Make sure the proper badge is in your possession (badge of the person who made the reservation).",
	"helpPage_vehicles_issue2_title": "Why does the card reader show only red light?",
	"helpPage_vehicles_issue3_answer": "If you have a booking, and light is green but you do not hear the doors unlocking, press the button on the driver door in order to unlock the doors.",
	"helpPage_vehicles_issue3_title": "Why do the doors remain closed?",
	"helpPage_vehicles_issue4_answer": "Make sure of the vehicle registration plate, your dates and times, make sure you have sufficient Internet connection.",
	"helpPage_vehicles_issue4_title": "Why can I not open the doors?",
	"helpPage_vehicles_issue5_answer": "Just make sure the engine is off, the doors and the trunk properly closed, that you have handed over the keys with the little chip in the box located in the glove box.",
	"helpPage_vehicles_issue5_title": "Why can I not lock the vehicle?",
	"home.header_banner": "In October, <strong>Renault Mobility</strong> will become <strong>Mobilize share</strong>",
	"home.welcome": "Welcome to {productName}",
	"home.welcome_solo": "Welcome",
	"how_it_works.step_1": "<span class='bold'>Download application</span> from the App Store or Google Play.",
	"how_it_works.step_2": "Launch application and <span class='bold'>register</span> by filling out the form.",
	"how_it_works.step_3": "Take a picture of your <span class='bold'>driver's license</span>, your <span class='bold'>identity card</span> and <span class='bold'>take a picture of yourself</span> with your ID card next to your face, save it all in the app!",
	"how_it_works.step_4": "<span class='bold'>Register your bank card</span> to manage the payment of your rentals.",
	"how_it_works.step_5": "<span class='bold'>Validate your email address</span> by clicking on the link sent to you. <span class='bold'>Check your SPAM folders</span>.",
	"how_it_works.step_6": "Once your registration is validated, <span class='bold'>reserve your vehicle</span> on our application or on our website. On the day of your reservation, <span class='bold'> your smartphone is your key!</span>",
	"info.account.company.already.linked": "This company already linked to your account",
	"info.switch.profile": "<strong>New — </strong>You can now add and manage multiple profiles using the same credentials. This allows you to join corporate fleets of you company and use the same app to rent a vehicle for your week-ends.",
	"info.switching.profile": "Switching profile",
	"info.worldpay.return.success": "Payment information attached",
	"iso__BE": "Belgium",
	"iso__CS": "Czechia",
	"iso__DA": "Danish",
	"iso__DE": "Germany",
	"iso__ES": "Spain",
	"iso__FR": "France",
	"iso__IT": "Italy",
	"iso__NL": "Netherlands",
	"iso__PL": "Poland",
	"iso__PT": "Portugal",
	"iso__SL": "Slovenia",
	"iso__SV": "Sweden",
	"iso__pt_BR": "Brazil",
	"label.accept_terms_and_conditions": "I agree to be contacted subsequently by Renault and its network by e-mail, for the purposes of investigation or information on new products as well as current offers. On the occasion of each sending, I will have the possibility to end all communication.",
	"label.account.already.active": "Your account is already active",
	"label.account_activation_description": "You will receive a confirmation by email when your account is validated and you can then take full advantage of the service.",
	"label.account_activation_title": "Congratulations, you have finalized your subscription. Your account will be reviewed promptly!",
	"label.activation.link.expired": "Activation link has expired",
	"label.activation.link.send": "Resend",
	"label.activation.link.sent.success": "The activation email will be sent if the user exists and the account is not activated",
	"label.active.profile": "Active profile",
	"label.actual.payment.method": "Your current payment method",
	"label.add.new.profile": "Add new profile",
	"label.apply": "Apply",
	"label.are_you_sure_you_want_to_cancel": "Would you like to confirm your cancellation?",
	"label.birth.day": "Date of birth",
	"label.booking": "Booking",
	"label.booking.past": "Past",
	"label.booking.past.placeholder": "Find here your bookings history.",
	"label.booking.today.part": "today at",
	"label.booking.upcoming.placeholder": "Find here your scheduled and in progress bookings",
	"label.cancel_my_booking": "Cancel my Reservation",
	"label.car": "vehicle",
	"label.carSharing": "Car sharing",
	"label.cars": "vehicles",
	"label.civility": "Civility",
	"label.click_here": "Click here",
	"label.close": "Close",
	"label.confirm_new_password": "Confirm password",
	"label.congratulations": "Congratulations!",
	"label.continue": "Continue",
	"label.creditCard_message": "In order to validate your card, a temporary debit will be made. A debit of a small amount {amountToTake} € may temporarily appear on the account associated with your card. If the debit persists for more than five working days, please contact your bank.",
	"label.date": "Date",
	"label.delivery_place": "Issue city",
	"label.driving_licence": "Driving license",
	"label.driving_licence_back": "Driver’s license (back side)",
	"label.driving_licence_front": "Driver’s license (front side)",
	"label.edit.invite.code": "Edit invite code",
	"label.expiration_date": "Expiration date",
	"label.file.upload.only.mobile": "To edit documents, please use the mobile app.",
	"label.filter_by": "Filter by",
	"label.filters": "Filters",
	"label.generic.error": "An error has occurred. Please try again later.",
	"label.hours": "hours",
	"label.how_it_works": "How it works?",
	"label.identity.card": "Identity card",
	"label.identity.document.number": "Identity document number",
	"label.identity.document.type": "Identity document type",
	"label.identity_card": "Identity document",
	"label.identity_card_back": "Identity document (back side)",
	"label.identity_card_front": "Identity document (front side)",
	"label.identity_card_selfie": "Selfie with your identity document",
	"label.invite_code_placeholder": "Enter your invite code",
	"label.italy.fiscal.code": "Enter your Italian fiscal code (only in CAPITAL LETTERS)",
	"label.italy.resident": "Do you live in Italy and possess an Italian fiscal number?",
	"label.licence_number": "Driving license number",
	"label.load_more": "More results",
	"label.login": "Log in",
	"label.logout": "Log out",
	"label.manager.email": "Email of your manager",
	"label.mandatory_fields": "* Mandatory fields",
	"label.member_already": "Already a member ?",
	"label.my_account": "My account",
	"label.my_reservations": "My bookings",
	"label.new.password": "New password",
	"label.no_account": "New member ?",
	"label.or_by_phone": "Or by phone",
	"label.password": "Password",
	"label.password_forgot": "Password forgotten",
	"label.phone": "Phone",
	"label.phone.suffix": "Phone suffix",
	"label.plateNumber": "Plate number",
	"label.price": "price",
	"label.redirectMobileApp": "To start your booking, download our mobile app!",
	"label.remember_me": "Stay logged in",
	"label.reset_password_done": "Your password has been updated",
	"label.return": "Back",
	"label.schedule": "Hours",
	"label.search": "Search",
	"label.selected.language": "Selected language",
	"label.subject": "Subject",
	"label.switch.profile": "Switch profile",
	"label.the": "to",
	"label.validate": "Validate",
	"label.vehicles_found": "{count} results found",
	"label.warning": "Warning",
	"label.welcome.finish.registration": "To confirm your appointment, please finish your registration.",
	"label.you_are_trying_to_cancel_your_booking": "You are about to cancel your reservation!",
	"label.your.active.profile": "Your active profile",
	"label.your.other.profiles": "Your other profiles",
	"label.your_message": "Your message",
	"language.header": "Select your language",
	"login.forgot_password": "Forgot your password ?",
	"login.register": "Register",
	"menu.faq": "Info",
	"mobile_banner.text": "Download {productName} application",
	"page.password.update.sub.title": "Due to security reasons we ask you to update your password",
	"page.password.update.title": "Password update",
	"parking.special_opening_legend": "Special opening hours",
	"part.company.fill.extra.info": "asks you to fill some additional information.",
	"part.complete.register.for": "Complete your registration for",
	"part.create.account.for": "Create an account for",
	"part.link.account.to": "Link your account to",
	"part.your.email": "your email",
	"placeholder.enter.number": "Enter a number ...",
	"placeholder.enter.text": "Type here ...",
	"placeholder.search": "Search ...",
	"profile.422.error.info": "It looks like some information are missing in your profile.\nLet's verify together your profile to make sure everything is OK.",
	"profile.info.new.email": "If you update your email address, you’ll receive an email to verify your email address. Without verifying it, you’ll no longer be able to create a booking.",
	"profile.label.before.arrival": "Before the arrival",
	"profile.label.before.departure": "Before the departure",
	"profile.label.charges.call.center": "For changes made by the call center",
	"profile.label.charges.my": "For changes made by me",
	"profile.label.current.password": "Current password",
	"profile.label.expiration.date.status": "My driving license doesn't have an expiration date",
	"profile.label.min.15": "15 minutes",
	"profile.label.min.30": "30 minutes",
	"profile.label.min.45": "45 minutes",
	"profile.label.new.email": "New email address",
	"profile.label.street.field": "Address (street number + street name)",
	"profile.label.validated.email": "Your validated email address",
	"profile.section.additional.info": "Additional information",
	"profile.section.credentials": "Credentials",
	"profile.section.language": "Profile language",
	"profile.section.notifications": "Notifications and alerts",
	"profile.section.payment.info": "Payment information",
	"profile.section.personal.info": "Personal information",
	"profile.section.selfie": "Selfie",
	"profile.section.technician.access": "Technician access",
	"profile.select.menu.item": "Please select a menu item on the left",
	"profile.selfie.section.info": "Please take a selfie, showing your identity card next to your face.",
	"profile.suspended": "Your profile is suspended",
	"profile.title.email.notifications": "Email notifications",
	"profile.title.language.select": "Language used for notifications and emails",
	"profile.title.sms.notifications": "SMS notifications",
	"profile.title.update.email": "Update your email address",
	"profile.title.update.password": "Update your password",
	"profile_error_driver_license_invalid": "The driving license is not valid",
	"register.field.info.password": "Must contain at least 1 number, 1 uppercase letter, 1 lowercase letter and between 8 and 25 characters",
	"register.info.payment.saved": "Payment method is saved.",
	"register.info.profile.creation.forbidden": "You can't link your profile to this company",
	"register.success.info": "An activation link has been sent to {email}. Please check your emails and spam folder, then follow the instructions to activate your account before the link expires.",
	"register.terms.ads": "I consent to the processing of my data for marketing purposes (with both automated and traditional methods) in relation to mobility products and / or services",
	"register.terms.prefix.accept": "I accept the",
	"register.terms.privacy.link.label": "Privacy policy",
	"register.terms.privacy.text": "I accept the {link} of {company}",
	"register.terms.root.privacy": "privacy policy",
	"register.terms.root.tos": "terms of subscription",
	"register.terms.root.tou": "terms of use",
	"register.terms.suffix.ads": "use of my details for commercial purposes",
	"register.terms.suffix.of": "of",
	"register.terms.usage.link.label": "Terms of use",
	"register.terms.usage.subscription.link.label": "Terms of subscription",
	"register.terms.usage.subscription.text": "I accept the {link} of {company}",
	"register.terms.usage.text": "I accept the {link} of {company}",
	"register.title.account.created": "Congrats {firstName}, your account has been created",
	"register.title.account.linked": "Congrats {firstName}, new profile has been linked to your account",
	"register.title.account.updated": "Congrats {firstName}, your account has been updated",
	"reset_password.title": "Password reset",
	"search.filter_alphabetically": "Alphabetically",
	"search.filter_by": "Sort by",
	"search.filter_by_price": "By price",
	"search.result.empty": "There is no result",
	"service.corporate.intro": "You want to join a community ? Please enter your invite code.",
	"service.intro_label": "Which {productName} service would you like to subscribe for ?",
	"service.private.intro": "You want to book a vehicle from {productName} network ?",
	"service.private.renaultfr": "To subscribe to {productName} please download the app on your mobile store.",
	"service.private.select_country": "Please select a country",
	"service.usage.corporate": "Corporate carsharing",
	"service.usage.private": "24/7 Car rental",
	"service.usage.vr": "Replacement vehicle",
	"service.vr.intro": "Thank you for your interest in our service !\n\nTo become a member, please contact your dealer to get a registration link.",
	"sncf.home.login.msg": "Are you an SNCF employee? Log in.",
	"sso.login.description": "Enter your work email address",
	"sso.login.title": "Connect with SSO",
	"status.APPROVED": "Profile validated",
	"status.NOT_APPROVED": "Your profile is rejected. Please update your profile.",
	"status.TO_COMPLETE": "Incomplete",
	"status.TO_REVIEW": "Your profile is pending validation",
	"tagline": "24/7 self-service car rental",
	"title.add.payment.later": "You may add it later.",
	"title.add.payment.method": "Please add a payment method.",
	"title.bookings.welcome.tutorial": "Find here your booking, it is already scheduled",
	"title.modify.booking": "Modify my booking",
	"title.password.change.success": "Your new password has been saved",
	"title.update.booking": "Update booking",
	"title.welcome.to.brand": "Hello {firstName}, welcome to {brandName}.",
	"title.welcome.to.program": "Hello {firstName}, welcome to {brandName} {program} program.",
	"vehicle.incorrect.usage": "The vehicle is not available for this usage type",
	"week.day.friday": "Friday",
	"week.day.monday": "Monday",
	"week.day.saturday": "Saturday",
	"week.day.sunday": "Sunday",
	"week.day.thursday": "Thursday",
	"week.day.tuesday": "Tuesday",
	"week.day.wednesday": "Wednesday"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/en.json
 ** module id = 421
 ** module chunks = 0
 **/